/**
 * Opens a dialog without its autofocus landing in the first field, and without letting focus stay
 * outside it.
 *
 * Settings is not a request to rename, so the dialog's own focus — which lands in the name field
 * and leaves the saved name selected for the next keystroke to replace — is prevented. Preventing
 * it alone is what broke the dialog: focus then stayed on the ⋮ button it was opened from, and
 * the first focus event outside the content counts as an interaction outside, so the dialog
 * dismissed itself the moment the menu behind it settled.
 *
 * The content is focusable in its own right (Radix gives it `tabIndex={-1}`), so parking focus
 * there keeps it inside the layer with no field selected.
 */
export const keepFocusInsideDialog = (event: Event): void => {
  event.preventDefault();

  if (event.currentTarget instanceof HTMLElement) event.currentTarget.focus();
};
